import React, { FC, useCallback, useRef } from 'react';
import classnames from 'classnames';

import { HomeFaqItemClose } from './_HomeFaqItemClose';
import { HomeFaqItemType } from './types';
import styles from './_HomeFaqItem.module.css';

interface HomeFaqItemProps {
    index: number;
    question: HomeFaqItemType;
    onOpen: (index: number) => void;
    active: boolean;
}

export const HomeFaqItem: FC<HomeFaqItemProps> = (props) => {
    const { index, active, question, onOpen } = props;
    const { title, answer } = question;

    const activeItem = useRef<HTMLDivElement>(null);

    const height = (active && activeItem.current?.clientHeight) || 0;

    const handleQuestionClick = useCallback(() => {
        onOpen(index);
    }, [onOpen, index]);

    return (
        <div className={styles.root}>
            <div className={styles.question} onClick={handleQuestionClick} role="presentation">
                <h3 className={classnames(styles.title, { [styles.titleActive]: active })}>
                    {title}
                </h3>
                <div
                    className={classnames(styles.iconWrapper, {
                        [styles.iconWrapperActive]: active,
                    })}
                >
                    <HomeFaqItemClose
                        className={classnames(styles.icon, { [styles.iconActive]: active })}
                    />
                </div>
            </div>
            <div className={styles.answer} style={{ height }}>
                <div
                    className={classnames(styles.inner, { [styles.innerActive]: active })}
                    ref={activeItem}
                >
                    <div className={styles.answerText}>{answer}</div>
                </div>
            </div>
        </div>
    );
};
